// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"866":"45fac859","2706":"45fac859","3091":"45fac859","5472":"45fac859","8153":"45fac859"}[chunkId] + ".chunk.css";
};